<pc-image-banner 
    [imgUrl]="this.bannerImgUrl || ''"
>
</pc-image-banner>

<div class="site-gutter white-gutter">
    <div class="main-copy-section">
        <div class="wrapper">
            <div class="copy-container">
                <div class="header-container">
                    <h1>Division 6</h1>
                    <h2>Wood & Plastics</h2>
                </div>
                <p>
                    Wood and plastics have a wide range of uses and applications for commercial projects. At PC Haines, we place a high priority on completing every project with top-quality materials to ensure you get a superior finished product. Whereas some companies may cut corners to help themselves, we focus on helping you by working with reliable suppliers who provide wood that isn't going to warp, bend, or break on the job. To see the wood and plastics work we offer, see our services below.
                </p>
            </div>
            <div class="circles services-circles">
                <pc-services-circles></pc-services-circles>
            </div>
        </div>
    </div>
</div>

<div class="secondary-content-section dark-section">
    <div class="site-gutter">
        <div class="card-container">
            <div class="card-row">
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">1</span>
                            <h3>Rough Carpentry</h3>
                        </div>
                    </div>
                    <p>Wood blocking is inserted between structural elements like metal studs or joists. It's used to provide support for attaching heavy items, like cabinets, railings, or fixtures, to ensure they are securely mounted. Plywood sheathing is used to add strength and support to walls in construction, providing a stable base for other materials. It's like the backbone of the building's structure. </p>
                </div>
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">2</span>
                            <h3>Sheathing</h3>
                        </div>
                    </div>
                    <p class="mb">Exterior gypsum sheeting is used as a fire-resistant, moisture-resistant layer under exterior cladding, like stucco or siding, providing structural support and enhanced durability. Exterior nail base insulation is used to improve energy efficiency by adding a layer of insulation to the outside of a building, reducing heat loss and improving moisture control. It's often used under siding or other exterior finishes.</p> 
                    <p>Structural Insulated Panels (SIPs) are building panels used for walls, roofs, and floors, made of an insulating foam core sandwiched between two structural facings, often oriented strand board (OSB). They're known for their strength, energy efficiency, and speed of construction. These products are attached to exterior metal framing or CMU walls. </p>
                </div>
            </div>
            <div class="card-row">
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">3</span>
                            <h3>Plastic Paneling</h3>
                        </div>
                    </div>
                    <p>FRP, or Fiber-Reinforced Plastic panels, are used for their durability, moisture resistance, and easy maintenance, making them ideal for high-traffic areas, commercial kitchens, bathrooms, and anywhere hygiene is crucial. This product is adhered to gypsum board or CMU walls.</p>
                </div>
                <div class="card">
                </div>
            </div>
        </div>
    </div>
</div>

<pc-seat-belt
    [copy]="'Ready to experience the PC Haines difference? Submit a bid request today.'"
    [buttonText]="'Submit a Request'"
    [buttonUrl]="'/contact-us'"
    [urlFragment]="'bid-request'"
></pc-seat-belt>